<template>
  <div class="pa-4">
    <v-skeleton-loader v-if="loading" class="mx-auto" type="card"></v-skeleton-loader>
    <div v-else>
      <v-card outlined>
        <div v-if="ready" class="text-center text-h4">Already completed</div>
        <div v-else-if="invited" class="text-center text-h4">Form sent on {{ $d(new Date(invited), "long",
          this.$i18n.locale) }}<br> waiting for approval</div>
        <div>
          <v-card-text>
            <template v-for="(i) in fields">
              <div :key="'inifini_cf_' + i.Id">
                <v-text-field :disabled="true" :name="i.UserDefinedId" dense outlined v-model="i.value"
                  :label="i.ShortName" :hint="i.PlaceholderText">
                </v-text-field>
              </div>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-btn outlined :disabled="disableForm" color="primary" elevation="0" @click="submitForm(true)">
              <v-progress-circular v-if="sendingForm" color="white" indeterminate size="20"
                class="mr-1"></v-progress-circular>
              Agree & Submit
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="goBack()" elevation="0">Cancel</v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Api from "@/services/Api";


export default {
  data() {
    return {
      loading: true,
      ready: false,
      invited: null,
      fields: [],
      disableForm: false,
      sendingForm: false,
    };
  },
  components: {
  },
  created() {
    Api()
      .get(
        "payments/v3/managedacademy/" +
        this.$store.state.managedAcademy +
        "/is_connected/infinicept"
      )
      .then((response) => {
        this.ready = response.data.infiniceptConnected;
        this.invited = response.data.invited;
        if (this.ready || this.invited) {
          this.disableForm = true;
        }
        this.loadForm();
      });
  },
  watch: {},
  methods: {
    goBack() {
      this.navigateTo({ name: "transactions" });
    },
    submitForm(submit) {
      //Check if all fields are ready
      let proceed = true;
      this.sendingForm = true;
      if (submit) {
        for (const f of this.fields) {
          if (!f.value) {
            proceed = false;
            break;
          }
        }
      }
      if (proceed) {
        Api()
          .post(
            "payments/v3/managedacademy/" +
            this.$store.state.managedAcademy +
            "/infinicept/onboarding", { submit: submit, fields: this.fields }
          )
          .then((response) => {
            if (response.data) {
              if (submit)
                this.disableForm = true;
              this.showAlert("success");
              this.sendingForm = false;
            }
          })
          .catch(() => {
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
            this.sendingForm = false;
          });
      } else {
        this.showAlert("error", this.$t('message.fill_all_parameters'));
        this.sendingForm = false;
      }
    },
    loadForm() {
      Api()
        .get(
          "payments/v3/managedacademy/" +
          this.$store.state.managedAcademy +
          "/infinicept/onboarding"
        )
        .then((response) => {
          if (response.data) {
            this.fields = response.data.fields;
            this.loading = false;
          }
        });
    },
  }
};
</script>

<style scoped></style>